import { useCallback, useState } from 'react';

/**
 * Returns a function that, when called with an error, re-throws it during a React state update
 * so that the nearest error boundary catches it.
 */
export const useErrorHandler = (): ((error: unknown) => void) => {
  const [, setState] = useState();
  return useCallback(
    (error: unknown) => {
      setState(() => {
        throw error;
      });
    },
    [setState]
  );
};
